import { useEffect } from 'react';

const setActiveQuote = ({ currentTarget, activeSliderIndex }) => {
  const activeDot = currentTarget
    .closest('.slider-with-quotes')
    .querySelector('.slider-with-quotes__dot_active');

  const dotItems = currentTarget
    .closest('.slider-with-quotes')
    .querySelectorAll('.slider-with-quotes__dot');

  const sliderItems = currentTarget
    .closest('.slider-with-quotes')
    .querySelectorAll('.slider-with-quotes__item');

  if (currentTarget !== activeDot) {
    activeDot.classList.remove('slider-with-quotes__dot_active');

    dotItems.forEach((item) => {
      if (activeSliderIndex === item.getAttribute('slider-index')) {
        item.classList.add('slider-with-quotes__dot_active');
      } else {
        item.classList.remove('slider-with-quotes__dot_active');
      }
    });

    sliderItems.forEach((item) => {
      if (activeSliderIndex === item.getAttribute('slider-index')) {
        item.classList.add('slider-with-quotes__item_active');
      } else {
        item.classList.remove('slider-with-quotes__item_active');
      }
    });
  }
};

const handleDotClick = ({ currentTarget }) =>
  setActiveQuote({
    currentTarget,
    activeSliderIndex: currentTarget.getAttribute('slider-index'),
  });

const handleButtonClick = ({ currentTarget }, itemsLength) => {
  const activeItem = currentTarget
    .closest('.slider-with-quotes')
    .querySelector('.slider-with-quotes__dot_active')
    .getAttribute('slider-index');

  const buttonLeft = currentTarget.classList.contains('slider-with-quotes__button_left');
  const buttonRight = currentTarget.classList.contains('slider-with-quotes__button_right');

  if (buttonLeft) {
    const prevSlide = activeItem === '1' ? String(itemsLength) : String(Number(activeItem) - 1);

    setActiveQuote({
      currentTarget,
      activeSliderIndex: prevSlide,
    });
  }

  if (buttonRight) {
    const nextSlide = String(itemsLength) === activeItem ? '1' : String(Number(activeItem) + 1);

    setActiveQuote({
      currentTarget,
      activeSliderIndex: nextSlide,
    });
  }
};

export default function useSliderQuotes() {
  useEffect(() => {
    const buttonsSlider = document.querySelectorAll('.slider-with-quotes__button');
    const dotItems = document.querySelectorAll('.slider-with-quotes__dot');

    buttonsSlider.forEach((item) =>
      item.addEventListener('click', (e) => handleButtonClick(e, dotItems.length))
    );
    dotItems.forEach((item) => item.addEventListener('click', handleDotClick));

    return () => {
      buttonsSlider.forEach((item) =>
        item.removeEventListener('click', (e) => handleButtonClick(e, dotItems.length))
      );
      dotItems.forEach((item) => item.removeEventListener('click', handleDotClick));
    };
  }, []);
}
